<div class="raptor-page-container" [formGroup]="form">
  <open-raptor-progress *ngIf="!(formData.settings && formData.settings.hide_progress_bar)" [progress]="formData.progress" [pages]="formData.total_pages"></open-raptor-progress>
  <open-raptor-banner-header *ngIf="formData.settings?.banners" [data]="formData.settings?.banners"></open-raptor-banner-header>
  <open-raptor-banner-header *ngIf="bannerHeaders" [data]="bannerHeaders"></open-raptor-banner-header>
  <div class="grid">
    <div class="cell margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary" type="button" (click)="raptorFormService.reset()" [disabled]="raptorStepService.loading"><mat-icon>west</mat-icon></button>
    </div>
  </div>

  <div class="raptor-page-content padding-bottom-xxbig">
    <div class="raptor-page-panel" [class]="raptorStepService.action" *ngIf="raptorStepService.stepReady">

      <div class="grid">
        <div class="raptor-page-main-panel cell cell-small-col-span-6 cell-large-col-span-12">
          <header class="margin-bottom-xmedium padding-horizontal-medium">
            <h1 class="text-center" [ngClass]="{'margin-bottom-medium': formData.subtext}" *ngIf="formData.heading">{{ formData.heading }}</h1>
            <p class="text-center margin-bottom-none" *ngIf="formData.subtext">
              <mat-icon>pin_drop</mat-icon>
              {{ formData.subtext }}
            </p>
          </header>
          <div class="raptor-page-price-frequency margin-bottom-medium">
            <div class="raptor-page-price-frequency-panel">
              <open-raptor-question *ngIf="frequencySwitch" [question]="frequencySwitch" [form]="form" [submitted]="true"></open-raptor-question>
            </div>
          </div>

          <!-- MAIN CONTENT -->
          <div class="raptor-page-price-container grid">
            <div *ngFor="let cover of formData.covers; let i = index"
              class="raptor-page-price-panel cell cell-small-col-span-6 cell-large-col-span-4"
              [ngClass]="{
                'cell-medium-col-span-4': formData.covers.length && formData.covers.length === 2 || formData.covers.length && formData.covers.length === 4,
                'cell-large-col-start-3': (formData.covers.length && formData.covers.length === 2 && (i === 0)) || (formData.covers.length && formData.covers.length === 4 && (i === 2)),
                'cell-large-col-start-5': formData.covers.length && formData.covers.length === 1,
                'cell-medium-col-start-3': formData.covers.length && formData.covers.length === 3 || formData.covers.length && formData.covers.length === 1
              }"
            >
              <div class="raptor-page-price-content">
                <h2 class="raptor-page-price-cover-name text-center">{{ cover.label }}</h2>

                <div *ngIf="cover.banner" class="raptor-page-price-banner-box margin-top-xsmall">
                  <div *ngFor="let banner of cover.banner">
                    <div *ngIf="banner.tag" class="margin-bottom-xsmall raptor-page-price-banner">
                      {{ getTagLabel(banner) }}
                    </div>
                  </div>
                </div>

                <open-price [price]="getCoverPrice(cover)" [precision]="0" class="margin-top-small margin-bottom-small"></open-price>

                <div class="raptor-page-price-premium form-typography padding-top-small padding-bottom-xsmall">
                  <label *ngIf="canEstimateSumInsured()" class="margin-bottom-xsmall flex flex-center">
                    <span class="margin-right-xxsmall">Sum insured estimate</span>
                    <open-tooltip [tooltipContent]="formData.settings.details[formData.data.cover_type].sum_insured_help.text"></open-tooltip>
                  </label>

                  <div *ngIf="formData.human && formData.human.sum_insured_building && ['home', 'home_contents', 'landlords'].indexOf(formData.data.cover_type) > -1" class="flex flex-content-center margin-bottom-xxsmall">
                    <label class="small margin-right-small flex">Home</label>
                    <span class="raptor-page-price-premium-break-value flex-grow text-small text-right">
                      {{ formData.human.sum_insured_building }}
                    </span>
                  </div>
                  <div *ngIf="formData.human && formData.human.sum_insured_contents && ['contents', 'home_contents'].indexOf(formData.data.cover_type) > -1" class="flex flex-content-center">
                    <label class="small margin-right-small flex">Contents</label>
                    <span class="raptor-page-price-premium-break-value flex-grow text-small text-right">
                      {{ formData.human.sum_insured_contents }}
                    </span>
                  </div>

                </div>

                <div class="page-price-select-cover margin-bottom-medium width-full">
                  <button mat-flat-button color="primary" type="button" class="width-full" (click)="selectCover(cover)" [disabled]="raptorStepService.loading">
                    <span *ngIf="!raptorStepService.loading">Continue</span>
                    <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
                  </button>
                </div>

                <div class="raptor-page-price-features width-full text-left margin-bottom-small">
                  <ul>
                    <li *ngFor="let feature of cover.features">
                      <mat-icon class="margin-right-xxsmall">check_circle_outline</mat-icon>
                      <span>{{ feature }}</span>
                    </li>
                  </ul>
                  <open-tooltip
                    [tooltipContent]="formData.settings.details[formData.data.cover_type].cover_level[cover.cover.cover_level].covered_help.text"
                    [tooltipType]="'link'"
                    [tooltipLabel]="'See what\'s covered'"
                  ></open-tooltip>
                </div>

                <div class="raptor-page-price-pds width-full text-center">
                  <p class="margin-none">
                    <span>Read </span>
                    <span *ngFor="let wording of cover.pds; let i = index">
                      <a (click)="openPdsDocument(wording.url)">{{ wording.name.replace('Policy wording - ', '') }}</a>
                      <span *ngIf="cover.pds.length > 1 && i === cover.pds.length - 2" class="text-default"> &amp; </span>
                      <span *ngIf="cover.pds.length > 1 && i < cover.pds.length - 2" class="text-default">, </span>
                    </span>
                    <span> policy wording</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <input type="hidden" formControlName="cover_level" id="cover_level" />
    <button type="submit" hidden id="coverSubmit">submit</button>

  </div>

  <div class="raptor-prices-marketing raptor-page-panel bg-secondary" [class]="raptorStepService.action" *ngIf="raptorStepService.stepReady && formData.settings && formData.settings.details && formData.settings.details[formData.data.cover_type]">
    <div class="grid text-center padding-horizontal-medium padding-vertical-xlarge">
      <div class="cell cell-small-col-span-6 cell-large-col-span-8 cell-large-col-start-3">
        <h2 class="margin-bottom-small">{{ formData.settings.details[formData.data.cover_type].marketing.heading }}</h2>

        <div class="grid margin-bottom-large" *ngIf="formData.settings.details[formData.data.cover_type].marketing.content.length">
          <div class="cell cell-large-col-span-6 cell-medium-col-span-4 cell-small-col-span-6 padding-top-medium" *ngFor="let item of formData.settings.details[formData.data.cover_type].marketing.content">
            <open-svg-icon [name]="item.icon" class="medium"></open-svg-icon>
            <h4 class="margin-top-small">{{ item.text }}</h4>
          </div>
        </div>

        <p class="padding-top-medium" *ngIf="formData.settings.details[formData.data.cover_type].marketing.footer" [innerHTML]="formData.settings.details[formData.data.cover_type].marketing.footer"></p>
      </div>
    </div>
  </div>

  <div *ngIf="disclaimers && raptorStepService.stepReady" class="grid grid-wrapper mat-typography margin-top-big">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <div *ngFor="let disclaimer of disclaimers; index as i">
        <div *ngIf="disclaimer" class="raptor-page-price-banner-disclaimer text-xsmall" [ngClass]="{'margin-bottom-xsmall':i > 1}" [innerHTML]="disclaimer">
        </div>
      </div>
    </div>
  </div>

  <div class="grid grid-wrapper" *ngIf="raptorStepService.stepReady" ngClass="{'padding-top-big': !disclaimers || !disclaimers.length}">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <p *ngIf="formData.disclaimer && formData.disclaimer.content" class="raptor-page-price-banner-disclaimer text-xsmall" [innerHTML]="formData.disclaimer.content"></p>
    </div>
  </div>
</div>
